import { AuthenticatedLayout } from "../../layouts";
import { FC } from "react";
import { WSIBOntarioRemittanceSetup } from "../../components/WSIBOntarioRemittanceSetup";

export interface IWSIBOntarioRemittancePage { }

export const WSIBOntarioRemittancePage: FC<IWSIBOntarioRemittancePage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="WSIB Remittance"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<WSIBOntarioRemittanceSetup />}
		/>
	);
};
